import {
    useEffect,
    useState
} from 'react';
import {
    Container,
    Content,
    Card,
    Input,
    Textarea,
    Actions,
    LoadingProgress,
    MessageAlert
} from './styled';
import { Alert } from '../../../../../../components';
import {
    FaRegCalendarAlt
} from "react-icons/fa";
import { toast } from 'react-toastify';
import {
    createHoliday,
    updateHoliday,
    disableHoliday
} from '../../../../../../service/serviceChat/holidayService';

export function HolidaysForm({ holiday, callback }) {

    const [disableHolidayMsg, setDisableHolidayMsg] = useState(false);
    const [holidayForm, setHolidayForm] = useState({
        name: '',
        message: '',
        date: ''
    });
    const [loading, setLoading] = useState({
        inProgress: false,
        order: null
    });

    useEffect(() => {
        if (holiday) {
            setHolidayForm({
                name: '',
                message: '',
                date: ''
            })
            mountHoliday(holiday);
        }
    }, []);

    const mountHoliday = async (holiday) => {
        const { nome, mensagem, dt_feriado } = holiday;
        setHolidayForm({
            name: nome ?? '',
            message: mensagem ?? '',
            date: dt_feriado ?? '',
        });
    };

    const subtitleLoadingProgress = (order) => {
        let subtitle
        switch (order) {
            case 1:
                subtitle = 'Criando Feriado...';
                break;
            case 2:
                subtitle = 'Atualizando Feriado...';
                break;
            case 3:
                subtitle = 'Excluindo Feriado...';
                break
            default:
                subtitle = '';
        }
        return subtitle
    };

    const verificationInputs = () => {
        if (!holidayForm?.name
            || !holidayForm?.message
            || !holidayForm?.date
        ) {
            toast.warn(
                'Por favor, preencha todos os campos !',
                {
                    position: "top-center",
                    theme: "colored",
                }
            );
            setLoading({
                inProgress: false,
                order: null
            })
            return false
        }
        return true
    };

    const resetStateComponent = () => {
        setHolidayForm((prevHolidayForm) => ({
            ...prevHolidayForm,
            name: '',
            date: '',
            message: '',
        }))
        setLoading({
            inProgress: false,
            order: null
        });
    };

    const haveChange = () => {
        return !(
            holiday?.nome === holidayForm?.name &&
            holiday?.mensagem === holidayForm?.message &&
            holiday?.dt_feriado === holidayForm?.date
        )
    };

    async function createHolidaySystem(dataHoliday) {
        setLoading({
            inProgress: true,
            order: 1
        });
        const holidayCreated = await createHoliday(dataHoliday);
        if (holidayCreated?.status_code === 201
            || holidayCreated?.status_code === 401
        ) {
            toast.success(
                'Feriado cadastrado com sucesso !',
                {
                    position: "top-center",
                    theme: "colored",
                }
            );
            callback();
            return;
        }
        toast.error(
            `${holidayCreated?.message}`,
            {
                position: "top-center",
                theme: "colored",
            }
        );
        return;
    };

    async function updateHolidaySystem(dataHoliday) {
        setLoading({
            inProgress: true,
            order: 2
        });
        if (haveChange()) {
            dataHoliday.id = holiday?.id
            const isUpdated = await updateHoliday(dataHoliday);
            if (isUpdated?.status_code === 200) {
                toast.success(
                    'Feriado alterado com sucesso !',
                    {
                        position: "top-center",
                        theme: "colored",
                    }
                );
                callback();
                return;
            }
            toast.error(
                `${isUpdated?.message}`,
                {
                    position: "top-center",
                    theme: "colored",
                }
            );
            return false
        }
        return
    };

    async function handDisableHoliday() {
        setDisableHolidayMsg(false);
        setLoading({
            inProgress: true,
            order: 3
        });
        await disableHoliday(holiday?.id);
        toast.success(
            `Feriado excluído com sucesso`,
            {
                position: "top-center",
                theme: "colored",
            }
        );
        callback();
        setLoading({
            inProgress: false,
            order: null
        });
    };

    async function handSave() {
        setLoading({
            inProgress: true,
            order: 1
        });
        if (verificationInputs()) {
            const isCreation = !(holiday)
            isCreation
                ? await createHolidaySystem(holidayForm)
                : await updateHolidaySystem(holidayForm);
        } else {
            resetStateComponent();
        }
    };

    return (
        <>
            <Container>
                <Content>
                    <Card>
                        <div className='title'>
                            <div>
                                <FaRegCalendarAlt fontSize={'1.3rem'} />
                                <span>
                                    {`Informações`}
                                </span>
                            </div>
                        </div>
                        <div>
                            <Input
                                id="date"
                                label="Data do Feriado"
                                type="date"
                                placeholder="Digite a data do feriado"
                                value={holidayForm?.date}
                                onChange={(e) => setHolidayForm((prevHolidayForm) => ({
                                    ...prevHolidayForm,
                                    date: e.target.value
                                }))}
                                disabled={!!holiday}
                            />
                            <Input
                                id="name"
                                label="Nome do Feriado"
                                type="text"
                                placeholder="Digite o nome do feriado"
                                value={holidayForm?.name}
                                onChange={(e) => setHolidayForm((prevHolidayForm) => ({
                                    ...prevHolidayForm,
                                    name: e.target.value
                                }))}
                                disabled={!!holiday}
                            />
                        </div>
                        <div>
                            <Textarea
                                id="message"
                                label="Mensagem"
                                type="textarea"
                                placeholder="Digite a mensagem a ser exibida"
                                value={holidayForm?.message}
                                onChange={(e) => setHolidayForm((prevHolidayForm) => ({
                                    ...prevHolidayForm,
                                    message: e.target.value
                                }))}
                                disabled={!!holiday}
                            />
                        </div>
                    </Card>
                    <Card>
                        {/* <Actions className={`jcSB ${!holiday ? 'onlyButton' : ''}`}>
                            {holiday &&
                                <div>
                                    <span
                                        className='dsUs'
                                        onClick={() => setDisableHolidayMsg(true)}
                                    >
                                        {`Desativar`}
                                    </span>
                                </div>
                            }
                            <button
                                onClick={() => handSave()}
                            >
                                {`Salvar`}
                            </button>
                        </Actions> */}
                        <Actions className={`jcSB ${!holiday ? 'onlyButton' : ''}`}>
                            {holiday ? (
                                <div>
                                    <span
                                        className='dsUs'
                                        onClick={() => setDisableHolidayMsg(true)}
                                    >
                                        {`Desativar`}
                                    </span>
                                </div>
                            ) : (
                                <button
                                    onClick={() => handSave()}
                                >
                                    {`Salvar`}
                                </button>
                            )}
                        </Actions>
                    </Card>
                </Content>
            </Container>
            <LoadingProgress
                isOpen={
                    (loading?.inProgress) ? 1 : 0
                }
            >
                <div>
                    <div>
                        <span className='loader'></span>
                    </div>
                    <div>
                        <p>
                            {subtitleLoadingProgress(loading?.order)}
                        </p>
                    </div>
                </div>
            </LoadingProgress>
            {(disableHolidayMsg) &&
                (<Alert
                    isOpen={true}
                    onClickOption1={
                        () => handDisableHoliday()
                    }
                    onClickOption2={
                        () => setDisableHolidayMsg(false)
                    }
                >
                    <MessageAlert>
                        <p>
                            {`Deseja realmente excluir o feriado ?`}
                        </p>
                    </MessageAlert>
                </Alert>)
            }
        </>
    )
}